import { OverlaySpinner } from "@app/components/OverlaySpinner.tsx";
import { Button } from "@app/components/shadcn/button.tsx";
import { ChevronLeft } from "lucide-react";
import type { PropsWithChildren, ReactNode } from "react";

type PageProps = PropsWithChildren<{
  title: ReactNode;
  subtitle?: ReactNode;
  isLoading?: boolean;
  className?: string;
  trailing?: ReactNode;
  onBack?: () => void;
}>;
export const Page = ({
  title,
  subtitle,
  trailing,
  onBack,
  className = "",
  isLoading = false,
  children,
}: PageProps) => {
  return (
    <div className={`flex flex-col grow p-4 md:p-6 ${className} gap-4`}>
      <div className="flex flex-1 justify-between items-center pb-3 border-b border-border/60">
        <div>
          {onBack ? (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="-ml-2 mb-1"
              onClick={onBack}
            >
              <ChevronLeft />
              Voltar
            </Button>
          ) : null}
          <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          ) : null}
        </div>
        {trailing}
      </div>
      {children}
      {isLoading && <OverlaySpinner />}
    </div>
  );
};
